import Vue     from 'vue'
import i18n    from '@/i18n'
import App     from '@/App.vue'
import router  from '@/router/'
import store   from '@/store'

// Plugins
import vuetify from '@/plugins/vuetify';

// Self components
import '@/plugins/base'
import '@/plugins/analytics'
import '@/plugins/firebase'

// Style
import "vue-material-design-icons/styles.css"
import '@/assets/css/main.css'

Vue.config.productionTip = true

new Vue({
  i18n,
  router,
  store,
  vuetify,
  created(){
    this.$store.dispatch('LOAD_RM'),
    this.$store.dispatch('LOAD_PM'),
    this.$store.dispatch('LOAD_CM'),
    this.$store.dispatch('LOAD_HM'),
    this.$store.dispatch('LOAD_LM')
  },
  render: h => h(App),
}).$mount('#app')
